import React, { useEffect, useState } from 'react'
import { TextField } from '@shopify/polaris'
import { useDebounce } from 'use-debounce'

const TextInputComponent = (props) => {
  const [inputValue, setInputValue] = useState(props.value)
  const [inputValueDebounced] = useDebounce(inputValue, 300)

  useEffect(() => {
    if (props.onChange) {
      props.onChange(props.name, inputValueDebounced)
    }
  }, [inputValueDebounced])

  useEffect(() => {
    setInputValue(props.value)
  }, [props.value])
  return (
    <TextField
      {...props}
      value={inputValue}
      onChange={setInputValue}
      error={props.error ? `${props.label} is required` : false}
    />
  )
}

export default TextInputComponent
